/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type appSageIntacct_viewer$ref: FragmentReference;
declare export opaque type appSageIntacct_viewer$fragmentType: appSageIntacct_viewer$ref;
export type appSageIntacct_viewer = {|
  +id: string,
  +company: ?{|
    +id: string,
    +sageIntacctEnabled: ?boolean,
    +workatoCustomerId: ?string,
    +workatoForecastSageIntacctConnectionId: ?string,
    +workatoSageIntacctConnectionId: ?string,
    +workatoIframeToken: ?string,
    +sageIntacctTimeRegsFromForecast: ?boolean,
    +sageIntacctSyncOnlyApproved: ?boolean,
  |},
  +$refType: appSageIntacct_viewer$ref,
|};
export type appSageIntacct_viewer$data = appSageIntacct_viewer;
export type appSageIntacct_viewer$key = {
  +$data?: appSageIntacct_viewer$data,
  +$fragmentRefs: appSageIntacct_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appSageIntacct_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sageIntacctEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "workatoCustomerId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "workatoForecastSageIntacctConnectionId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "workatoSageIntacctConnectionId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "workatoIframeToken",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sageIntacctTimeRegsFromForecast",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sageIntacctSyncOnlyApproved",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
// prettier-ignore
(node/*: any*/).hash = '8eec676717a3bdaf75f90c2bdb0b743b';

module.exports = node;
